import { Box, styled } from "@mui/material";

export const ItemContainer = styled(Box)`
  display: flex;
  gap: 12px;
  padding: 0.6rem 1.5rem 0.6rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
  &:hover {
    background-color: #f1f3f5;
    transform: translateX(2px);
  }
  &:active {
    background-color: #e9ecef;
  }
`;

export const EmptyState = styled(Box)`
    display: flex;
    align-items: center;
    padding: 0.6rem 1.5rem 0.6rem 1rem;
    color: #47404f;
    /* Static message, not a menu entry: no pointer, no hover feedback. */
    cursor: default;
    user-select: none;

    @media (max-width: 415px) {
        height: 100px;
    }
`;

export const Title = styled(Box)`
    color: black !important;
    max-width: 15rem;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const Date = styled(Box)`
  color: ${({ $isRead }) => ($isRead ? "#E8E8E8" : "#F66700")};

  font-size: 14px;
  display: flex;
  gap: 0.2rem;
`;

export const Read = styled(Box)`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  transform: translateY(4px);
  background-color: ${({ $isRead }) => ($isRead ? "#E8E8E8" : "#F66700")};
  margin-top: 100%;
`;
